import { usePost } from './useApi';

export interface PricingRequest {
  studentId: number;
  scheduleId: number;
  selectedDays: {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
  };
}

export interface PricingResponse {
  scheduleId: number;
  price: number;
  daysCount: number;
  appliedDiscount: {
    type: 'none' | 'concurrent' | 'organizational';
    originalPrice?: number;
    discountAmount?: number;
  };
}

export interface BulkPricingRequest {
  studentId: number;
  schedules: Array<{
    scheduleId: number;
    selectedDays: {
      monday: boolean;
      tuesday: boolean;
      wednesday: boolean;
      thursday: boolean;
      friday: boolean;
    };
  }>;
}

export const useCalculatePrice = () => {
  return usePost<PricingResponse, PricingRequest>(
    '/v1/auth/reg/pricing/calculate'
  );
};

export const useCalculateBulkPricing = () => {
  return usePost<PricingResponse[], BulkPricingRequest>(
    '/v1/auth/reg/pricing/calculate-bulk'
  );
};

// Utility function to convert selected days format
export const convertSelectedDaysFormat = (days: {
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
}) => {
  return {
    monday: !!days.monday,
    tuesday: !!days.tuesday,
    wednesday: !!days.wednesday,
    thursday: !!days.thursday,
    friday: !!days.friday,
  };
};
